// extracted by mini-css-extract-plugin
export default {"count":"Count_count__P05Oc","count__minus":"Count_count__minus__0DZnG","count__plus":"Count_count__plus__ASJ66"};